export const color_list = [
    '#02a499', '#f8b425', '#ec4561', '#38a4f8', '#3c4ccf', '#6f42c1', '#f46a6a', '#564ab1', '#33E3FF', '#E000FF', '#A90000', '#00FFA2', '#008BFF'
]

export const color_list_donut = [
    '#02a499', '#f8b425', '#ec4561', '#38a4f8', '#3c4ccf', '#6f42c1', '#f46a6a', '#564ab1', '#33E3FF', '#E000FF', '#A90000', '#00FFA2', '#008BFF'
]
